import { TypographyOptions } from '@mui/material/styles/createTypography';
import fonts from './fonts';
import linkBase from './linkBase';

const fontDefinition = {
  fontFamily: `${fonts.Static}, "Segoe UI", Arial, sans-serif`,
  '@supports (font-variation-settings: normal)': {
    fontFamily: `${fonts.Variable}, "Segoe UI", Arial, sans-serif`,
  },
};

const sizes = {
  body1: {
    FontSize: '18px',
    LineHeight: '28px',
  },
  body2: {
    FontSize: '16px',
    LineHeight: '24px',
  },
  body3: {
    FontSize: '14px',
    LineHeight: '20px',
  },
  body4: {
    FontSize: '13px',
    LineHeight: '18px',
  },
  body5: {
    FontSize: '12px',
    LineHeight: '16px',
  },
  body6: {
    FontSize: '10px',
    LineHeight: '12px',
  },
};

const typography: TypographyOptions = {
  ...fontDefinition,
  h0: {
    fontWeight: fonts.weights.Black,
    fontSize: '48px',
    lineHeight: '60px',
  },
  h1: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: '36px',
    lineHeight: '44px',
  },
  h2: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: '28px',
    lineHeight: '36px',
  },
  h3: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: '22px',
    lineHeight: '28px',
  },
  h5: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: '18px',
    lineHeight: '24px',
  },
  linkCaption: {
    ...linkBase,
  },
  subHeadline1: {
    fontWeight: fonts.weights.Medium,
    fontSize: '28px',
    lineHeight: '32px',
  },
  subHeadline2: {
    fontWeight: fonts.weights.Medium,
    fontSize: '22px',
    lineHeight: '32px',
  },
  subHeadline3: {
    fontWeight: fonts.weights.Medium,
    fontSize: '18px',
    lineHeight: '28px',
  },
  body1: {
    fontWeight: fonts.weights.Regular,
    fontSize: sizes.body1.FontSize,
    lineHeight: sizes.body1.LineHeight,
  },
  body1Medium: {
    fontWeight: fonts.weights.Medium,
    fontSize: sizes.body1.FontSize,
    lineHeight: sizes.body1.LineHeight,
  },
  body1Bold: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: sizes.body1.FontSize,
    lineHeight: sizes.body1.LineHeight,
  },
  body2: {
    fontWeight: fonts.weights.Regular,
    fontSize: sizes.body2.FontSize,
    lineHeight: sizes.body2.LineHeight,
  },
  body2Medium: {
    fontWeight: fonts.weights.Medium,
    fontSize: sizes.body2.FontSize,
    lineHeight: sizes.body2.LineHeight,
  },
  body2Bold: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: sizes.body2.FontSize,
    lineHeight: sizes.body2.LineHeight,
  },
  body3: {
    fontWeight: fonts.weights.Regular,
    fontSize: sizes.body3.FontSize,
    lineHeight: sizes.body3.LineHeight,
  },
  body3Medium: {
    fontWeight: fonts.weights.Medium,
    fontSize: sizes.body3.FontSize,
    lineHeight: sizes.body3.LineHeight,
  },
  body3Bold: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: sizes.body3.FontSize,
    lineHeight: sizes.body3.LineHeight,
  },
  body4: {
    fontWeight: fonts.weights.Regular,
    fontSize: sizes.body4.FontSize,
    lineHeight: sizes.body4.LineHeight,
  },
  body4Medium: {
    fontWeight: fonts.weights.Medium,
    fontSize: sizes.body4.FontSize,
    lineHeight: sizes.body4.LineHeight,
  },
  body4Bold: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: sizes.body4.FontSize,
    lineHeight: sizes.body4.LineHeight,
  },
  body5: {
    fontWeight: fonts.weights.Regular,
    fontSize: sizes.body5.FontSize,
    lineHeight: sizes.body5.LineHeight,
  },
  body5Medium: {
    fontWeight: fonts.weights.Medium,
    fontSize: sizes.body5.FontSize,
    lineHeight: sizes.body5.LineHeight,
  },
  body5Bold: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: sizes.body5.FontSize,
    lineHeight: sizes.body5.LineHeight,
  },
  body6: {
    fontWeight: fonts.weights.Regular,
    fontSize: sizes.body6.FontSize,
    lineHeight: sizes.body6.LineHeight,
  },
  body6Medium: {
    fontWeight: fonts.weights.Medium,
    fontSize: sizes.body6.FontSize,
    lineHeight: sizes.body6.LineHeight,
  },
  solTitle: {
    fontWeight: fonts.weights.SemiBold,
    fontSize: '22px',
    lineHeight: '28px',
  },
  bodyCompact: {
    fontWeight: fonts.weights.Medium,
    fontSize: '14px',
    lineHeight: '18px',
  },
  overline: {
    fontWeight: fonts.weights.Medium,
    fontSize: '12px',
    lineHeight: '16px',
  },
};

export default typography;
